import { ACCENT } from '../../styles/tokens';
import { useClusterStore } from '../../stores/clusterStore';
import { Sparkline } from '../ui/Sparkline';
import { useAgentHealth, type AgentHealthStatus } from '../../hooks/useAgentHealth';

const DOT: Record<AgentHealthStatus, string> = {
  ok: 'bg-okDot',
  degraded: 'bg-warnDot',
  down: 'bg-dangerDot',
  unknown: 'bg-textSoft',
};

const LABEL: Record<AgentHealthStatus, string> = {
  ok: 'online',
  degraded: 'degradado',
  down: 'offline',
  unknown: '…',
};

function agoLabel(at: number | null): string {
  if (at == null) return 'sem dados';
  const s = Math.max(0, Math.round((Date.now() - at) / 1000));
  if (s < 60) return `há ${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `há ${m}m`;
  return `há ${Math.floor(m / 60)}h`;
}

export function AgentHealthFooter() {
  const activeSlug = useClusterStore(s => s.activeSlug);
  const clusters = useClusterStore(s => s.clusters);
  const cluster =
    activeSlug !== 'all'
      ? clusters.find(c => c.slug === activeSlug)
      : undefined;
  const { status, latency, lastAt, samples } = useAgentHealth(
    cluster?.id ?? null
  );

  if (!cluster) return null;

  const lineColor =
    status === 'down' ? '#e11d48' : status === 'degraded' ? '#d97706' : ACCENT;

  return (
    <div
      className="mt-auto rounded-lg border border-borderSoft bg-bg px-2 py-1.5"
      data-testid="agent-health-footer"
      title={`Agente líder · ${cluster.slug}`}
    >
      <div className="flex items-center justify-between gap-1.5">
        <span className="flex min-w-0 items-center gap-1.5">
          <span
            className={`h-1.5 w-1.5 flex-shrink-0 rounded-full ${DOT[status]}`}
            aria-hidden
          />
          <span className="truncate font-mono text-[10px] text-textMute">
            agente · {LABEL[status]}
          </span>
        </span>
        <span className="flex-shrink-0 font-mono text-[10px] text-textMute tabular-nums">
          {latency != null ? `${latency}ms` : '—'}
        </span>
      </div>
      <div className="mt-1 h-[18px]">
        <Sparkline data={samples} w="100%" h={18} color={lineColor} strokeWidth={1.2} />
      </div>
      <div className="mt-0.5 font-mono text-[9px] text-textSoft">
        {agoLabel(lastAt)}
      </div>
    </div>
  );
}

export default AgentHealthFooter;
